import { Link } from 'react-router'
import { ROUTES } from '@/shared/config'
import logoSvg from '@/assets/logo.svg'

export function Header() {
  return (
    <header className="bg-surface-900/80 backdrop-blur-xl border-b border-white/[0.06] sticky top-0 z-50">
      <div className="flex items-center justify-between h-16 sm:h-20 max-w-[1920px] mx-auto px-4 sm:px-6">
        <Link to={ROUTES.HOME} className="flex items-center">
          <img src={logoSvg} alt="FinGrowInvest" className="h-8" />
        </Link>

        <nav className="flex items-center gap-2 sm:gap-3">
          <Link to={ROUTES.REVIEWS} className="text-xs sm:text-sm font-bold text-gray-400 hover:text-white transition-colors px-2 sm:px-3 py-1.5">
            Reviews
          </Link>
          <Link to={ROUTES.LOGIN} className="text-xs sm:text-sm font-bold text-gray-400 hover:text-white transition-colors px-2 sm:px-3 py-1.5">
            Sign In
          </Link>
          <Link to={ROUTES.REGISTER} className="text-xs sm:text-sm font-bold bg-amber-500 hover:bg-amber-400 text-black px-3 sm:px-4 py-1.5 rounded-lg transition-colors">
            Sign Up
          </Link>
        </nav>
      </div>
    </header>
  )
}
